import { jsxs as c, jsx as l } from "react/jsx-runtime";
import { E as f, S as g } from "./icons.types-0722eef5.js";
function w({ title: o, titleId: a, size: i, width: r, height: h, extended: n = !1, ...t }) {
  const s = n ? f : g, d = i ? s[i] : r || s[n ? "s" : "l"], e = i ? s[i] : h || s[n ? "s" : "l"];
  return /* @__PURE__ */ c(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 72 72",
      width: d,
      height: e,
      "aria-labelledby": a,
      ...t,
      children: [
        o ? /* @__PURE__ */ l("title", { id: a, children: o }) : null,
        /* @__PURE__ */ c("g", { clipPath: "url(#Icon_svg__a)", children: [
          /* @__PURE__ */ l(
            "path",
            {
              fill: "currentColor",
              d: "M67.62 19.261a8.293 8.293 0 0 0-5.834-5.873C56.639 12 36 12 36 12s-20.639 0-25.786 1.388a8.293 8.293 0 0 0-5.835 5.873C3 24.441 3 35.25 3 35.25s0 10.809 1.38 15.989a8.293 8.293 0 0 0 5.834 5.873C15.361 58.5 36 58.5 36 58.5s20.639 0 25.786-1.388a8.294 8.294 0 0 0 5.835-5.873C69 46.059 69 35.25 69 35.25s0-10.809-1.38-15.989Z"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              fill: "#FFF",
              d: "M29.25 45.063V25.436L46.5 35.25l-17.25 9.813Z"
            }
          )
        ] }),
        /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "Icon_svg__a", children: /* @__PURE__ */ l(
          "path",
          {
            fill: "#FFF",
            d: "M0 0h72v72H0z"
          }
        ) }) })
      ]
    }
  );
}
export {
  w as Icon
};
